var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.65 0L0 .609 4.698 5 0 9.391.65 10 6 5 .65 0z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--chevron-right-cfe45b9cc12705e3cdd580702b2c8db9.svg";
export { SvgIconUiChevronRight as Component };